import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legacy-app-links',
  templateUrl: './legacy-app-links.component.html',
  styleUrls: ['./legacy-app-links.component.scss'],
  standalone: false,
})
export class LegacyAppLinksComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
